import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X, Send } from 'lucide-react';
import { ChatModal } from './ChatModal';
export function ChatAvatar() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      {/* Floating Avatar Button */}
      <motion.div className="fixed bottom-6 right-6 z-40" initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 0.5,
      ease: 'easeOut'
    }} data-id="element-17">
        <motion.button onClick={() => setIsOpen(true)} className="relative group" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} data-id="element-18">
          {/* Animated Ring 1 (Outer) */}
          <motion.div className="absolute inset-0 rounded-full bg-gradient-to-r from-primary via-indigo to-steel" animate={{
          scale: [1, 1.3, 1],
          opacity: [0.6, 0, 0.6]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} style={{
          width: '80px',
          height: '80px'
        }} data-id="element-19" />

          {/* Animated Ring 2 (Middle) */}
          <motion.div className="absolute inset-0 rounded-full bg-gradient-to-r from-indigo via-primary to-steel" animate={{
          scale: [1, 1.2, 1],
          opacity: [0.4, 0, 0.4]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.5
        }} style={{
          width: '80px',
          height: '80px'
        }} data-id="element-20" />

          {/* Avatar Container - Fixed Image */}
          <div className="relative w-20 h-20 rounded-full overflow-hidden shadow-2xl" data-id="element-21">
            {/* Gradient Border Effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-primary via-indigo to-steel p-[3px] rounded-full" data-id="element-22">
              <div className="w-full h-full bg-white rounded-full flex items-center justify-center" data-id="element-23">
                <img src="https://cdn.magicpatterns.com/uploads/wTkjRNYGvfvZ13Kbit9Piz/WhatsApp_Image_2026-01-04_at_19.53.47.jpg" alt="Asesor Virtual" className="w-full h-full object-cover rounded-full" data-id="element-24" />
              </div>
            </div>
          </div>

          {/* Message Icon Badge */}
          <motion.div className="absolute -top-1 -right-1 w-8 h-8 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center shadow-lg" animate={{
          scale: [1, 1.2, 1]
        }} transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-25">
            <MessageCircle className="w-4 h-4 text-white" data-id="element-26" />
          </motion.div>

          {/* Tooltip */}
          <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-27">
            <div className="bg-navy text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap shadow-xl" data-id="element-28">
              ¿Necesitas ayuda? Chatea con nosotros
              <div className="absolute left-full top-1/2 -translate-y-1/2 border-8 border-transparent border-l-navy" data-id="element-29"></div>
            </div>
          </div>
        </motion.button>
      </motion.div>

      {/* Chat Modal */}
      <ChatModal isOpen={isOpen} onClose={() => setIsOpen(false)} data-id="element-30" />
    </>;
}